var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_401"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_401",
    "data-name": 401,
    className: "cls-2",
    d: "M68.58,92.4c-9,7.12-24.87,7.39-34.1.39-11-8.33-8.6-24-6.73-36.4C31.64,30.71,48.07.5,60.06,2.29,73.24,4.27,75.21,44,75.91,58.07,77.22,84.59,71.07,90.42,68.58,92.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog401);
export default __webpack_public_path__ + "static/media/dog_401.1537f28df70ea25e737aca93b72946d7.svg";
export { ForwardRef as ReactComponent };